<template>
  <div>
    <v-app-bar
      color="primary"
      dark
      fixed
      app
    >
      <v-toolbar-title
        class="title--text"
        style="cursor:pointer"
        @click="$router.push('/')">Prosense</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        class="ma-2"
        outlined
        @click="$router.push('/parent/top')"
        >父兄の方はこちら
      </v-btn>
      <v-btn
        class="ma-2"
        outlined
        @click="$router.push('/teacher/signup')"
      >
        ユーザー登録
      </v-btn>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  name: 'TeacherUnLoggedInAppToolBar'
}
</script>
